import 'modernizr'; // eslint-disable-line
import 'lazysizes';
import porta from 'porta';
import nl from 'porta/src/i18n/nl';
import '../vendor/bootstrap';

import Tracking from '../modules/tracking';
import Accessibility from '../modules/accessibility';
import FormValidation from '../modules/formValidation';
import header from '../modules/header';
import navigation from '../modules/navigation';
import toTop from '../modules/toTop';
import slider from '../modules/slider';
import sliderThumbs from '../modules/sliderThumbs';
import toggle from '../modules/toggle';
import controlledInput from '../modules/controlledInput';
import jumpToElement from '../modules/jumpToElement';
import cart from '../modules/cart';
import singleProduct from '../modules/singleProduct';
import cookieBar from '../modules/cookieBar';
import embedWrap from '../modules/embedWrap';
import alert from '../modules/alert';
import cartPayment from '../modules/cartPayment';
import filter from '../modules/filter/filter';
import searchComplete from '../modules/searchComplete';
import headerSearch from '../modules/headerSearch';
import captionSlider from '../modules/captionSlider';
import colorSelect from '../modules/colorSelect';
import product from '../modules/product';
import productSubmit from '../modules/productSubmit';
import productZoom from '../modules/productZoom';
import colorFilter from '../modules/colorFilter';
import relatedProductSubmit from '../modules/relatedProductSubmit';
import cartModal from '../modules/cartModal';
import subscribeNewsletterModal from '../modules/subscribeNewsletterModal';

const general = () => {
  window.app.tracking = new Tracking(window.app);
  window.app.accessibility = new Accessibility(window.app);
  window.app.formValidation = new FormValidation();
  window.app.header = header.initialize();
  navigation.initialize();
  toTop.initialize();
  slider.initialize();
  sliderThumbs.initialize();
  toggle.initialize();
  controlledInput.initialize();
  jumpToElement.initialize();
  cart.initialize();
  singleProduct.initialize();
  cookieBar.initialize();
  embedWrap();
  alert.initialize();
  cartPayment.initialize();
  filter.initialize();
  searchComplete.initialize();
  headerSearch.initialize();
  captionSlider.initialize();
  colorSelect.initialize();
  product.initialize();
  productSubmit.initialize();
  productZoom.initialize();
  colorFilter.initialize();
  relatedProductSubmit.initialize();
  cartModal.initialize();
  subscribeNewsletterModal.initialize();

  // insert-definition
  porta({
    messages: nl,
  });

  document.addEventListener('lazybeforeunveil', (e) => {
    const bg = e.target.getAttribute('data-bg');

    if (bg) {
      e.target.style.backgroundImage = `url(${bg})`;
    }
  });
};

export default general;
